import React, {ReactNode} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

export interface RuleEditorRecipeStepProps {
  step: number;
  sideElement?: ReactNode;
}

/*
 * Styles.
 */

const StyledContainerDiv = styled.div`
  display: grid;
  grid-template-areas: 'step title side';
  grid-template-columns: 30px auto max-content;
  grid-column-gap: 10px;
  align-items: center;

  font-weight: ${fontWeights.black};
  color: ${(p) => p.theme.greys.shade90};
  margin-bottom: 24px;
`;

const StyledStepDiv = styled.div`
  ${center()}

  grid-area: step;
  border-radius: 100px;
  background-color: ${(p) => p.theme.greys.shade20};
  width: 30px;
  height: 30px;
  font-size: ${fontSizes.medium};
`;

const StyledContentDiv = styled.div`
  grid-area: title;
  font-size: ${fontSizes.veryLarge};
`;

const StyledSideDiv = styled.div`
  grid-area: side;
`;

/*
 * Component.
 */

export const RuleEditorRecipeStep: React.FC<RuleEditorRecipeStepProps> = (props) => {
  const {step, children, sideElement} = props;

  return (
    <StyledContainerDiv>
      <StyledStepDiv>{step}</StyledStepDiv>
      <StyledContentDiv>{children}</StyledContentDiv>
      <StyledSideDiv>{sideElement ?? null}</StyledSideDiv>
    </StyledContainerDiv>
  );
};
